module.exports = "<p>\n  recovery-report-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/recovery-reports/recovery-report-form/recovery-report-form.component.html
// module id = ./src/app/recovery/recovery-reports/recovery-report-form/recovery-report-form.component.html
// module chunks = main